@use "@fukuri-admins/ui/layout" as *;

// オーバーレイ（背景暗転）
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: $Black_Alpha_50;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

// ダイアログ本体
// role="dialog" / aria-* の付与が必要なため Stack（属性を透過しない）ではなく div + flex で実装
.dialog {
  background: background('Primary');
  border-radius: borderRadius('xl');
  box-shadow: elevation('level3');
  width: 864px;
  max-width: 90vw;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  padding: spacing("24");
  gap: spacing("24");
}

.title {
  @include typography('Jp/16_W6');
  color: text('High');
}

.description {
  @include typography('Jp/14_W3');
  color: text('Low');
}

// コンテンツ部（利用人数 + 送付先）
.content {
  flex: 1;
  overflow-y: auto;
}

.label {
  @include typography('Jp/14_W3');
  color: text('High');
  width: 172px;
  flex-shrink: 0;
}

.value {
  @include typography('Jp/14_W3');
  color: text('High');
  flex: 1;
}

.addressValue {
  @include typography('Jp/14_W3');
  color: text('High');
  flex: 1;

  p {
    margin: 0;
  }
}

.contactLink {
  @include typography('Jp/14_W3');
  color: text('Link');
  text-decoration: none;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
}
